import $http from '@/services/http-common'
import firebaseService from '@/services/firebase.service'

export default {
  state: {
    ebook: null,
    ebooks: [],
    userEbooks: [],
    ebooksList: [],
    userDiscoverEbooksList: []
  },
  mutations: {
    setEbooksList (state, payload) {
      state.ebooksList = payload
    },
    setEbook (state, payload) {
      state.ebook = payload
    },
    setEbookFromEbooksListToIsRead (state, payload) {
      state.ebooksList = state.ebooksList.map(e => {
        if (e.id === payload.ebookId) {
          e.isRead = true
        }
        return e
      })
    },
    setEbookFromEbooksListSectionId (state, payload) {
      state.ebooksList = state.ebooksList.map(e => {
        if (e.id === payload.ebookId) {
          e.sectionId = payload.sectionId
        }
        return e
      })
    },
    setEbookFromEbooksToIsRead (state, payload) {
      state.ebooks = state.ebooks.map(e => {
        if (e.id === payload.ebookId) {
          e.isRead = true
        }
        return e
      })
    },
    setUserDiscoverEbooksList (state, payload) {
      state.userDiscoverEbooksList = payload
    },
    setEbooks (state, payload) {
      state.ebooks = payload
    },
    setUserEbooks (state, payload) {
      state.userEbooks = payload
    }
  },
  actions: {
    async getEbookByCode ({ commit }, payload) {
      try {
        commit('setFullPageLoading', true)
        const idToken = await firebaseService.getToken()
        const { data } = await $http.get(`/api/ebooks?code=${payload.ebookCode}`, {
          headers: {
            idToken
          }
        })
        commit('setEbook', data)
        commit('setFullPageLoading', false)
      } catch (error) {
        console.error(error)
        commit('setFullPageLoading', false)
      }
    },
    async getUserDiscoverEbooks ({ commit }) {
      try {
        const idToken = await firebaseService.getToken()
        const uid = await firebaseService.getUID()
        const { data } = await $http.get(`/api/users/${uid}/discover`, {
          headers: {
            idToken
          }
        })
        commit('setUserDiscoverEbooksList', data)
      } catch (error) {
        console.error(error)
        commit('setError', error.message)
      }
    },
    async loadDiscoverEbooks ({ commit }, payload) {
      try {
        const idToken = await firebaseService.getToken()
        let query = '/api/ebooks?type=discover'
        if (payload && payload.limit) {
          query = `${query}&limit=${payload.limit}`
        }
        const { data } = await $http.get(query, {
          headers: {
            idToken
          }
        })
        commit('setEbooksList', data)
      } catch (error) {
        console.error(error)
      }
    },
    async loadListEbooks ({ commit }, payload) {
      try {
        commit('setFullPageLoading', true)
        const idToken = await firebaseService.getToken()
        let query = `/api/lists/${payload.uriParam}`
        const { data } = await $http.get(query, {
          headers: {
            idToken
          }
        })
        commit('setList', data.list)
        commit('setEbooksList', data.ebooks)
        commit('setFullPageLoading', false)
      } catch (error) {
        console.error(error)
        commit('setFullPageLoading', false)
      }
    },
    async loadEbookData ({ commit }, payload) {
      try {
        commit('setFullPageLoading', true)
        const { data } = await $http.get(`/api/ebooks/${payload.ebookId}`)
        commit('setEbook', data)
        commit('setFullPageLoading', false)
      } catch (error) {
        console.error(error)
        commit('setFullPageLoading', false)
      }
    },
    async updateEbookOnAmazonLinkClick ({ commit, state }) {
      try {
        const ebook = state.ebook
        if (ebook && ebook.amazonAffiliateUrl) {
          window.open(ebook.amazonAffiliateUrl, '_blank')
          ebook.amazonLinkClickCount = ebook.amazonLinkClickCount + 1
          const { data } = await $http.put(`/api/ebooks/${ebook.id}`, {
            amazonLinkClickCount: ebook.amazonLinkClickCount
          })
          commit('setEbook', data)
        }
      } catch (error) {
        console.error(error)
      }
    }
  },
  getters: {
    getEbooksList (state) {
      return state.ebooksList
    },
    getEbook (state) {
      return state.ebook
    },
    getEbooks (state) {
      return state.ebooks
    },
    getUserDiscoverEbooksList (state) {
      return state.userDiscoverEbooksList
    },
    getUserEbooks (state) {
      return state.userEbooks
    }
  }
}
